import { useCallback } from 'react';
import { PermissionsAndroid } from 'utils/packages/permissionsAndroid';
import { Camera } from 'utils/packages/Camera';
import { usePermissions } from 'hooks/usePermissions';
import { mapIOSPermissions } from 'utils/permissions';
export var PermissionStatus;
(function (PermissionStatus) {
    PermissionStatus[PermissionStatus["unknown"] = 0] = "unknown";
    PermissionStatus[PermissionStatus["busy"] = 1] = "busy";
    PermissionStatus[PermissionStatus["allowed"] = 2] = "allowed";
    PermissionStatus[PermissionStatus["denied"] = 3] = "denied";
    PermissionStatus[PermissionStatus["banned"] = 4] = "banned";
})(PermissionStatus || (PermissionStatus = {}));
export const usePermissionsCamera = (rationale) => {
    const readIOSPermissions = useCallback(() => Promise.resolve(mapIOSPermissions(Camera.getCameraPermissionStatus())), []);
    const askIOSPermissions = useCallback(() => Camera.requestCameraPermission().then(mapIOSPermissions), []);
    return usePermissions(PermissionsAndroid.PERMISSIONS.CAMERA, rationale, readIOSPermissions, askIOSPermissions);
};
